<ag-grid-angular style="width: 630px; margin: 0 auto;"
        class="ag-theme-material tc-ag-grid tc-ag-grid--popup-content"
        [rowData]="passengerList"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [pagination]="true"
        [paginationAutoPageSize]="true"
        (gridReady)="onGridReady($event)">
</ag-grid-angular>